/** @jsxRuntime classic */
/** @jsx jsx */
import { useCallback } from 'react';
import { jsx, css } from '@emotion/react';
import { useFormikContext, Form } from "formik";
import { Prompt } from 'react-router-dom';
import ErrorComponent from '../Util/ErrorComponent';
import SuccessComponent from '../Util/SuccessComponent';
import NavigationalButtons from '../Util/NavigationalButtons';
import PrimaryButton from '../Forms/PrimaryButton';

const SaveButton = ({ handleSave, dirty, submitting, disabledSave }) => {
    return (
        <div className="save-btn-container">
            <PrimaryButton
                onClick={handleSave}
                text="Save"
                disabled={disabledSave || !dirty || submitting}
            />
        </div>
    );
};


const FormStepWrapper = ({ 
  children, 
  handleSave, 
  showSuccess, 
  showError,
  setShowSuccess,
  setShowError,
  successMessage,
  errorMessage,
  unsavedMsg,
  showNavigation = true,
  firstStep = 0,
  lastStep = 2,
  rootCss,
  selectedKey,
  setSelectedKey,
  disabledSave = false,
  hidePrompt = false,
}) => {
  const { dirty, isSubmitting } = useFormikContext();
  const nextOnClick = useCallback(() => setSelectedKey(String(Number(selectedKey) + 1)), [selectedKey, setSelectedKey]);
  const prevOnClick = useCallback(() => setSelectedKey(String(Number(selectedKey) - 1)), [selectedKey, setSelectedKey]);

  return (
      <Form css={rootCss}>
        {!hidePrompt && 
          <Prompt when={dirty} message={unsavedMsg} />
        }
          <div className="mt-1 form-container">
            {children}
            {showNavigation && (
            <div className="nav-btn-box">
                <NavigationalButtons
                onNextHandler={selectedKey !== String(lastStep) ? nextOnClick : false}
                onPrevHandler={selectedKey !== String(firstStep) ? prevOnClick : false}
                />
            </div>
              )}
              <SaveButton handleSave={handleSave} dirty={dirty} submitting={isSubmitting} disabledSave={disabledSave} />
          </div>
          <SuccessComponent successMessage={successMessage} showSuccess={showSuccess} setShowSuccess={setShowSuccess} />
          <ErrorComponent errorMessage={errorMessage} showError={showError} setShowError={setShowError} />
      </Form>
  );
};

export default FormStepWrapper;
